import axios from 'axios';
import authHeader from './auth-header';

const api = axios.create({
    baseURL: 'https://app.effzone.com/api',
    headers: {
        'Content-Type': 'application/json',
    },
});

api.interceptors.request.use(
    (config) => {
        const token = authHeader()['x-access-token'];
        if (token) {
            config.headers['x-access-token'] = token;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

api.interceptors.response.use(
    (res) => {
        return res;
    },
    async (err) => {
        const originalConfig = err.config;

        // Check if the request is not an auth request and we got 401
        if (!originalConfig.url.startsWith('/auth/') && err.response && err.response.status === 401 && !originalConfig._retry) {
            originalConfig._retry = true;

            localStorage.removeItem("user");
            window.location.href = '/login';
        }

        return Promise.reject(err);
    }
);

export default api; 